import type { CSSObject, SerializedStyles } from '@emotion/react'
import { css } from '@emotion/react'
import { Color, FontWeight, Spacing, Typography } from '@opallabs/gem'

export const popover: CSSObject = {
  paddingBlock: Spacing.S * 1.25,
  paddingInline: Spacing.S * 2.5,
  textAlign: 'center',
  userSelect: 'none',
  inlineSize: Spacing.XL * 5,
}

export const popoverText: CSSObject = {
  color: Color.light.Text.Default,
  ...Typography.T300,
  paddingBlockEnd: Spacing.XS / 4,
  paddingBlockStart: Spacing.S,
  paddingInline: Spacing.XS * 1.25,
  display: 'block',
}

export const popoverDate: CSSObject = {
  color: Color.light.Text.Gray,
  ...Typography.M500,
  fontSize: 11,
  fontWeight: FontWeight.Bold,
  display: 'block',
}

export const popoverHr: CSSObject = {
  backgroundColor: Color.light.Surface.N300,
  blockSize: 1,
  marginInline: '5%',
  marginBlockStart: Spacing.XS / 2,
  inlineSize: '90%',
}

export const popoverDateTitle = (warn = false): SerializedStyles =>
  css({
    color: warn ? Color.light.Text.Warning : Color.light.Text.Gray,
    ...Typography.M500,
    fontSize: 11,
    fontWeight: FontWeight.Bold,
    display: 'block',
  })
